import {FormattedMessage, defineMessages} from 'react-intl';

import {view} from '@sail/ui';

export const messages = defineMessages({
  reauthenticationNotice: {
    id: 'support_conversations_client.reauthenticationNotice',
    description:
      'The text shown when a user session needs to be re-authenticated.',
    defaultMessage:
      'Your session has expired. Please re-authenticate to continue.',
  },
});

export function ReauthenticationNotice() {
  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'medium',
        font: 'body.small',
      }}
    >
      <view.p>
        <FormattedMessage {...messages.reauthenticationNotice} />
      </view.p>
    </view.div>
  );
}
